import { seo } from "@/utils/seo";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/calendars")({
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Calendars",
  }),
  head: () => ({
    meta: seo({ title: "Calendars" }),
  }),
});
